import { useEffect, useMemo } from "react";
import jwt_decode from "jwt-decode";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Preload } from "../../components/Preload";
import { useAuth } from "../../hooks/useAuth";
import { refreshSession } from "../../services/sessions";

function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

export function SignAsUser() {
  const navigate = useNavigate();
  const { token } = useParams();
  const { persistUser } = useAuth();

  let query = useQuery();
  const shortToRedirect = query.get("shortToRedirect");

  useEffect(() => {
    async function loadStorageData(): Promise<void> {
      const userToken: any = jwt_decode(token as string);
      const response = await refreshSession({
        token: token as string,
        userId: userToken?.user_id,
      });
      const { user, permissions } = response;
      await persistUser(user, permissions, token as string);

      if (shortToRedirect) {
        // navigate(`/${shortToRedirect}`);
        window.location.assign(`/${shortToRedirect}`);
      } else {
        navigate("/");
      }
    }

    loadStorageData();
  }, [token, navigate, persistUser, shortToRedirect]);

  return <Preload loading />;
}
